import { Component, Input } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { constants } from '@well/infra/constants';
import { PlatformLegalEntityInvoicingTermsDto } from '@well/platform-administration/company/domain';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabel } from 'primeng/floatlabel';
import { FormInlineErrorDirective } from '@irian-ro/shared-ui';
import { InputNumber, InputNumberModule } from 'primeng/inputnumber';

@Component({
    selector: 'well-platform-legal-entity-invoicing-terms-inputs',
    imports: [FloatLabel, FormsModule, TranslateModule, InputTextModule, InputNumberModule, FormInlineErrorDirective, InputNumber],
    templateUrl: './platform-legal-entity-invoicing-terms-inputs.component.html',
    styleUrls: ['./platform-legal-entity-invoicing-terms-inputs.component.scss'],
    viewProviders: [constants.nestedTemplateFormsViewProviders]
})
export class PlatformLegalEntityInvoicingTermsInputsComponent {

  @Input() platformLegalEntityInvoicingTermsDTO: PlatformLegalEntityInvoicingTermsDto = new PlatformLegalEntityInvoicingTermsDto();

}
